import { render, staticRenderFns } from "./AdminTrainLayout.vue?vue&type=template&id=1ffb3ee8&scoped=true"
import script from "./AdminTrainLayout.vue?vue&type=script&lang=js"
export * from "./AdminTrainLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminTrainLayout.vue?vue&type=style&index=0&id=1ffb3ee8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb3ee8",
  null
  
)

export default component.exports